import { RegionCard } from 'components/cards/region-card';
import { UnderlineButton } from 'components/dynamic-content/button';
import Link from 'next/link';
import React from 'react';
import { BASE_PATH } from 'utils/constants';
import { RegionInfoFragment } from 'utils/gqlReactTypings.generated.d';
import { ShallowCityPage, ZipPage } from 'utils/types';
import { encodeCityPageHref, encodeZipPageHref } from 'utils/urls';
import { ListSection } from './list-section';

interface IProps {
  regions: RegionInfoFragment[];
  cityPages: ShallowCityPage[];
  zipPages: ZipPage[];
}

export const LinkColumns: React.FC<IProps> = ({ regions, cityPages, zipPages }) => (
  <div className='mb-16 flex flex-col gap-8 md:gap-10'>
    <ListSection
      title='We Deliver Homemade Food in the Following Metros'
      seeAll='See all'
      titleHref={`${BASE_PATH}/metros-we-serve`}>
      {regions.map((region) => (
        <RegionCard key={region.id} region={region} />
      ))}
    </ListSection>

    <div className='mb-8 flex flex-col gap-6 md:mb-16 md:gap-8'>
      <div className='flex w-full flex-row items-start justify-between gap-4'>
        <div className='flex flex-col items-start justify-start'>
          <div className='text-red-950 leading-trim-both text-edge-cap justify-start text-xl font-bold leading-[120%] sm:text-2xl md:text-3xl'>
            Top cities
          </div>
        </div>
        <div className='flex w-36 flex-col items-end justify-end'>
          <UnderlineButton
            link={`${BASE_PATH}/cities-we-serve`}
            text='See all'
            className='w-fit'
            underlineWidth='w-12'
          />
        </div>
      </div>
      <div className='grid w-full grid-cols-2 gap-3 md:flex md:flex-wrap md:gap-4'>
        {cityPages.map((cityPage) => (
          <Link key={cityPage.id} href={encodeCityPageHref(cityPage)}>
            <div className='inline-flex w-full items-center justify-between rounded-lg bg-white p-4 shadow-[10px_8px_16px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-offset-[-1px] outline-neutral-100 md:w-80'>
              <div className='text-red-950 justify-center text-sm font-medium leading-relaxed sm:text-base md:text-lg'>
                {cityPage.cityName}, {cityPage.stateNameShort}
              </div>
              <i className='fa fa-chevron-right text-red-950 text-sm' />
            </div>
          </Link>
        ))}
      </div>
    </div>

    <div className='mb-8 flex flex-col gap-6 md:mb-16 md:gap-8'>
      <div className='flex w-full flex-row items-start justify-between gap-4'>
        <div className='flex flex-col items-start justify-start'>
          <div className='text-red-950 leading-trim-both text-edge-cap justify-start text-xl font-bold leading-[120%] sm:text-2xl md:text-3xl'>
            Top zip codes
          </div>
        </div>
        <div className='flex w-24 flex-col items-end justify-end'>
          <UnderlineButton
            link={`${BASE_PATH}/zip-codes-we-serve`}
            text='See all'
            className='w-fit'
            underlineWidth='w-12'
          />
        </div>
      </div>
      <div className='grid w-full grid-cols-2 gap-3 md:flex md:flex-wrap md:gap-4'>
        {zipPages.map((zipPage) => (
          <Link key={zipPage.id} href={encodeZipPageHref(zipPage, zipPage.zipCode)}>
            <div className='inline-flex w-full items-center justify-between rounded-lg bg-white p-4 shadow-[10px_8px_16px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-offset-[-1px] outline-neutral-100 md:w-80'>
              <div className='text-red-950 justify-center text-sm font-medium leading-relaxed sm:text-base md:text-lg'>
                {zipPage.zipCode}
              </div>
              <i className='fa fa-chevron-right text-red-950 text-sm' />
            </div>
          </Link>
        ))}
      </div>
    </div>
  </div>
);
